// API Configuration
// Auto-detect the correct API URL based on the current domain
const getBaseAPIUrl = () => {
  // In development, always use localhost
  if (process.env.NODE_ENV === 'development') {
    return process.env.REACT_APP_API_URL || 'http://127.0.0.1:5000/api';
  }
  
  // In production, use the current domain to avoid CORS issues
  const currentOrigin = window.location.origin; // Gets www.phinlex.com or phinlex.com
  return `${currentOrigin}/api`;
};

const API_BASE_URL = getBaseAPIUrl();
const FINAL_API_BASE_URL = API_BASE_URL.endsWith('/api') ? API_BASE_URL : `${API_BASE_URL}/api`;

// For uploads, we need to handle different environments
// Production: Uses current domain to match www/non-www
// Development: http://127.0.0.1:5000/uploads/files
const getStaticBaseUrl = () => {
  if (process.env.NODE_ENV === 'production') {
    return FINAL_API_BASE_URL; // Production: use /api prefix (same domain)
  }
  return process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://127.0.0.1:5000'; // Development: remove /api
};

const STATIC_BASE_URL = getStaticBaseUrl();

export const API_ENDPOINTS = {
  BASE_URL: FINAL_API_BASE_URL,
  UPLOADS: `${STATIC_BASE_URL}/uploads/files`,
  TRAININGS: `${FINAL_API_BASE_URL}/trainings`,
  PUBLIC_TRAININGS: `${FINAL_API_BASE_URL}/public/trainings`,
  AUTH: `${FINAL_API_BASE_URL}/auth`,
  USERS: `${FINAL_API_BASE_URL}/users`,
  SLIDERS: `${FINAL_API_BASE_URL}/public/sliders`,
  ADMIN_SLIDERS: `${FINAL_API_BASE_URL}/admin/sliders`,
} as const;

export default API_ENDPOINTS;
